// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resource-list-details-container .choices__item.choices__item--choice.choices__item--selectable{color:#4467ab}.resource-list-details-container .choices__item.choices__item--choice.choices__item--selectable svg[role=img]{color:#4467ab}", ""]);
// Exports
module.exports = exports;
